import { useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Radio, RadioGroup } from "@nextui-org/react";

import { useUpdateQuizOption } from "../hooks/useUpdateQuizOption";
import Input from "../../../../components/input/Input";
import Button from "../../../../components/Button";

function UpdateOption({ option, isCorrect, optionId, onCloseModal }) {
    const [correctAnswer, setCorrectAnswer] = useState();
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            option,
            is_correct: isCorrect,
        },
    });

    const { courseId, lectureId, itemId, questionId } = useParams();
    const {
        updateQuizOption,
        isUpdating,
        error: ApiError,
    } = useUpdateQuizOption();

    function onSubmit({ option }) {
        //Send The Form Data To The API
        updateQuizOption(
            {
                courseId,
                lectureId,
                itemId,
                questionId,
                optionId,
                option,
                is_correct: correctAnswer,
            },
            {
                onSuccess: () => {
                    reset();
                    onCloseModal?.();
                },
            }
        );
    }

    return (
        <>
            <h3 className="py-5 text-xl text-center text-blue-color-primary">
                تعديل الأختيار
            </h3>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Input
                    label={`الاختيار `}
                    name={`option`}
                    type="text"
                    size="full"
                    register={register("option", {
                        required: "برجاء ادخال الأختيار",
                    })}
                    error={ApiError?.response?.data?.errors?.option?.[0]}
                    disabled={isUpdating}
                />
                <RadioGroup
                    orientation="horizontal"
                    value={correctAnswer}
                    onValueChange={setCorrectAnswer}
                    color="primary"
                    className="py-5"
                >
                    <Radio value={true}>صحيح</Radio>
                    <Radio value={false}>خاطئ</Radio>
                </RadioGroup>
                <div className="w-full pt-3">
                    <Button
                        type="primary"
                        className="w-full leading-8"
                        disabled={isUpdating}
                    >
                        إضافة اختيار
                    </Button>
                </div>
            </form>
        </>
    );
}
export default UpdateOption;
